import React, { Component } from 'react';
import { gsap } from 'gsap';

import { scenesPropTypes } from './prop-types';
import animationData from '../../lotties/05';
import SceneHeading from '../SceneHeading';
import SceneContent from '../SceneContent';
import SceneSlides from '../SceneSlides';
import Slide from '../Slide';
import SlideTitle from '../SlideTitle';
import SlideText from '../SlideText';
import FiguresTable from '../FiguresTable';
import SvgPicto from '../SvgPicto';
import Link from '../Link';
import VideoPlayer from '../Players/VideoPlayer';
import { ReactComponent as W1M1 } from '../../images/w1-m1.svg';
import { ReactComponent as W1M2 } from '../../images/w1-m2.svg';
import { ReactComponent as W4M5 } from '../../images/w4-m5.svg';

/**
 * Scene5
 */

class Scene5 extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.pictosComponents = {
      'w1-m1': W1M1,
      'w1-m2': W1M2,
      'w4-m5': W4M5,
    };

    /** Refs */
    this.element = React.createRef();
    this.heading = React.createRef();
    this.tween = React.createRef();
    this.slides = this.props.data.slides.map(() => React.createRef());
    this.slidesTweens = [];
    this.links = [];
    this.medias = [];
    this.props.data.slides.forEach((slide, index) => {
      this.slidesTweens[index] = {};
      if (slide.type === 'text-figures' && slide.figures) {
        this.slidesTweens[index].figures = React.createRef();
      }
      if (slide.type === 'picto' && slide.picto) {
        this.slidesTweens[index].picto = React.createRef();
      }
      if (slide.type === 'link' && slide.link) {
        this.links[index] = React.createRef();
      }
      if (slide.type === 'media' && slide.video) {
        this.medias[index] = React.createRef();
      }
    });
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    /** Setup a GSAP Tween for each link and media */
    this.links.map((link, index) => (this.slidesTweens[index].link = gsap.from(link.current, { opacity: 0, duration: 1, paused: true })));
    this.medias.map((media, index) => (this.slidesTweens[index].media = gsap.from(media.current.element.current, { opacity: 0, duration: 1, paused: true })));

    /** Mount the slides tweens to the Scene timeline */
    this.props.mountSlides(this.slides, this.tween.current);
  }

  render() {
    return (
      <div ref={this.element} className="scene-wrapper">
        <SceneHeading ref={this.heading} title={this.props.title} animationData={animationData} />
        <SceneContent layout={this.props.data.layout}>
          <SceneSlides ref={this.tween} align={this.props.data.align} length={this.props.data.slides.length} layout="arrow">
            {this.props.data.slides.map((slide, index) => (
              <Slide key={index} ref={this.slides[index]} type={slide.type} align={slide.align} layout={slide.layout}>
                {slide.type === 'picto' && slide.picto && (
                  <>
                    <SvgPicto ref={this.slidesTweens[index].picto} svg={this.pictosComponents[slide.picto]} color={slide.color} />
                  </>
                )}
                {(slide.type === 'text' || slide.type === 'picto') && slide.title && (
                  <>
                    <SlideTitle title={slide.title} color={slide.color} />
                  </>
                )}
                {(slide.type === 'text' || slide.type === 'picto' || slide.type === 'text-figures') && slide.text && (
                  <div className={`${index < 2 ? 'text-small' : ''} ${slide.color ? `strong-${slide.color}` : ''}`}>
                    <SlideText text={slide.text} />
                  </div>
                )}
                {slide.type === 'text-figures' && slide.figures && (
                  <>
                    <FiguresTable ref={this.slidesTweens[index].figures} figures={slide.figures} columns={3} dots />
                  </>
                )}
                {slide.type === 'link' && slide.link && (
                  <p>
                    <Link ref={this.links[index]} url={slide.link.url} title={slide.link.title} icon="arrow-thin-right" layout="round-button" />
                  </p>
                )}
                {slide.type === 'media' && slide.video && (
                  <>
                    <VideoPlayer ref={this.medias[index]} url={slide.video} />
                  </>
                )}
              </Slide>
            ))}
          </SceneSlides>
        </SceneContent>
      </div>
    );
  }
}

Scene5.propTypes = scenesPropTypes;

export default Scene5;
